import React from "react";
import { RateEditor } from "./RateEditor";
import type { RateEditorMenuProps } from "./types";

/**
 * Wrapper component for RateEditor used in Cell context menu.
 * Provides the same props interface but can be extended for menu-specific behavior.
 */
export function RateEditorMenu(props: RateEditorMenuProps) {
  return <RateEditor {...props} />;
}
